interface IProps {
  title?: string;
  subtitle?: string;
  additionalText?: string | React.ReactNode;
}

export const PageHeader: React.FC<IProps> = ({ title, subtitle, additionalText }) => {
  return (
    <header className="flex flex-col justify-end border-b border-slate-300 bg-white pb-4 pl-6">
      <div className="flex flex-col">
        <h1 className="font-semibold md:text-3xl">{title}</h1>
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
          {subtitle && <h2 className="text-sm font-normal text-slate-900 md:text-base">{subtitle}</h2>}
          {additionalText && <h3 className="mt-2 pr-4 text-sm font-normal text-slate-900 lg:ml-4 lg:mt-0">{additionalText}</h3>}
        </div>
      </div>
    </header>
  );
};
